export default __webpack_public_path__ + "static/media/Business Standard.9e0edfc5.png";